import React, { useState } from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import KanbanCard from './KanbanCard';

export default function KanbanColumn({ board, cards, onAddCard, onCardClick }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [adding, setAdding] = useState(false);

  const droppableId = String(board.boardID);

  const handleAdd = async () => {
    if (!newTitle.trim() || adding) return;
    setAdding(true);
    try {
      await onAddCard(board.boardID, newTitle.trim());
      setNewTitle('');
      setShowAddForm(false);
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="kanban-column">
      <div className="kanban-column-wrapper">
        <div className="kanban-column-header">
          <div className="kanban-column-title-wrap">
            <span className="kanban-column-title" title={board.boardName}>
              {board.boardName}
            </span>
            <span className="kanban-column-count">{board.cardCount}</span>
          </div>
        </div>

        {showAddForm ? (
          <div className="tasks-add-card-form">
            <input
              type="text"
              placeholder="Enter card title"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleAdd();
                if (e.key === 'Escape') setShowAddForm(false);
              }}
              autoFocus
            />
            <div className="tasks-add-card-actions">
              <button type="button" className="tasks-btn-primary" onClick={handleAdd} disabled={adding}>
                Add
              </button>
              <button type="button" className="tasks-btn-secondary" onClick={() => setShowAddForm(false)}>
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <button
            type="button"
            className="kanban-add-card-btn kanban-add-card-btn-top"
            onClick={() => setShowAddForm(true)}
          >
            + Add a card
          </button>
        )}

        <Droppable droppableId={droppableId}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`kanban-column-cards${snapshot.isDraggingOver ? ' drag-over' : ''}`}
            >
              {cards.map((card, index) => (
                <Draggable
                  key={String(card.cardID)}
                  draggableId={String(card.cardID)}
                  index={index}
                >
                  {(dragProvided, dragSnapshot) => (
                    <KanbanCard
                      card={card}
                      isDragging={dragSnapshot.isDragging}
                      innerRef={dragProvided.innerRef}
                      draggableProps={dragProvided.draggableProps}
                      dragHandleProps={dragProvided.dragHandleProps}
                      style={dragProvided.draggableProps.style}
                      onCardClick={onCardClick}
                    />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
}
